import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

export const IstitutiHero = () => (
  <section className="relative px-6 pt-40 pb-20 lg:pt-56 lg:pb-36" data-testid="istituti-hero-section">
    <Reveal className="max-w-4xl mx-auto text-center">
      <Eyebrow className="mb-8">Per gli Istituti</Eyebrow>
      <h1 className="font-extrabold tracking-[-0.05em] leading-[0.9] text-7xl sm:text-8xl lg:text-[10rem]" data-testid="istituti-hero-title">
        Prodigy
      </h1>
      <p className="mt-10 mx-auto max-w-[62ch] text-lg sm:text-xl leading-relaxed text-titanium" data-testid="istituti-hero-subtitle">
        <span className="text-white font-semibold">Percorsi di orientamento e Formazione Scuola-Lavoro (ex PCTO) chiavi in mano.</span> Connettiamo le tue
        classi alle migliori realtà del territorio, azzerando il carico di lavoro dei docenti.
      </p>
    </Reveal>
  </section>
);
